import React, { Fragment } from 'react';
import QuoteSuccess from './QuoteSuccess';
import QuoteFailed from './QuoteFailed';
import iconTransform from 'src/helpers/iconTransform.js';

const QuoteBase = props => {
  const { quoteStatus, showText, icon, align, ...otherProps } = props;

  const alignClass = align === 'R' ? 'right-align' : align === 'C' ? 'center-align' : 'left-align';

  return quoteStatus ? (
    <Fragment>
      <div className={`control-text ${alignClass}`}>
        {icon && <div className={'control-icons control-icons-inline'}>{iconTransform(icon, { fontSize: 30 })}</div>}
        <div className={'control-icons-inline-controls'}>
          <QuoteSuccess {...otherProps} />
        </div>
      </div>
    </Fragment>
  ) : (
    <Fragment>
      <div className={`control-text ${alignClass}`}>
        <div className={'control-icons control-icons-inline'}>
          {icon && (align === 'L' || align === 'C' || align === 'R') && <span>{iconTransform(icon, { fontSize: 30 })}</span>}
        </div>
        <div className={'control-icons-inline-controls quote-parent'}>
          <QuoteFailed {...otherProps} />
        </div>
      </div>
    </Fragment>
  );
};

export default QuoteBase;
